import baseUrl from '../config'
export const prefixImgUrl = {
    // bind(el, value) {
    //     const prefix = baseUrl.ossUrl
    //     el.src = prefix + value.value
    // }
    inserted: function (el, binding) {
        if (binding.value) {
            const prefix = baseUrl.ossUrl
            el.setAttribute('src', prefix + binding.value);
        }
    },
    // 当VNode更新时
    update: function (el, binding) {
        if (binding.value) {
            const prefix = baseUrl.ossUrl
            el.setAttribute('src', prefix + binding.value);
        }
    }
}
export const prefixImg = (src) => {

    const prefix = baseUrl.ossUrl
    return prefix + src
}